import { Done as DoneIcon } from "@mui/icons-material";
import { Box, Button, Divider, Typography } from "@mui/material";
import { WorkItemList, WorkItemStateEnum } from "../../../store/services/timelineApiRTK";
import { formatDate } from "../../next-action/helpers";

interface ActivityPanelFooterProps {
  activity: WorkItemList | undefined;
  onFinishClick: () => void;
}

const ActivityPanelFooter = ({
  activity,
  onFinishClick,
}: ActivityPanelFooterProps) => {
  if (!activity) return null;

  const isActive = activity.State === WorkItemStateEnum.Active;

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        bgcolor: "grey.50",
        borderTop: "1px solid",
        borderColor: "grey.200",
      }}
    >
      {isActive && (
        <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
          <Button
            startIcon={<DoneIcon />}
            color="success"
            variant="contained"
            size="small"
            onClick={onFinishClick}
            sx={{ borderRadius: 2, textTransform: "none", flex: 1 }}
          >
            Slutför
          </Button>
        </Box>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Skapad {formatDate(activity.Created || "")}
        </Typography>
        {activity.ChangedBy && (
          <>
            <Divider orientation="vertical" flexItem />
            <Typography variant="caption" color="text.secondary">
              Ändrad {formatDate(activity.Modified || "")}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ActivityPanelFooter;
